import { render, staticRenderFns } from "./AdminTags.vue?vue&type=template&id=1b36d429"
import script from "./AdminTags.vue?vue&type=script&lang=js"
export * from "./AdminTags.vue?vue&type=script&lang=js"
import style0 from "./AdminTags.vue?vue&type=style&index=0&id=1b36d429&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports